module.exports = __webpack_public_path__ + "img/blueLoadding.d5e0b529.png";